<template>
    <form
        role="search"
        method="get"
        :class="{
            PageSearch: true,
            'is-active': isActive,
        }"
        @submit="onSubmit"
        @keydown.enter="onSubmit"
        @keydown.esc="onHide"
        v-click-outside="onHide"
    >
        <div class="PageSearch-toggle" @click="onToggle">
            <slot>
				<svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<g id="Icon/Search" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<rect id="Clear-Space" x="0" y="0" width="18" height="18"></rect>
						<g transform="translate(9.500000, 10.000000) rotate(-45.000000) translate(-9.500000, -10.000000) translate(4.000000, 1.000000)" fill="#001e60" fill-rule="nonzero">
							<path d="M5.5,12 C5.74545989,12 5.94960837,12.1768752 5.99194433,12.4101244 L6,12.5 L6,17.5 C6,17.7761424 5.77614237,18 5.5,18 C5.25454011,18 5.05039163,17.8231248 5.00805567,17.5898756 L5,17.5 L5,12.5 C5,12.2238576 5.22385763,12 5.5,12 Z" id="Path-7"></path>
							<path d="M5.5,0 C2.46243388,0 0,2.46243388 0,5.5 C0,8.53756612 2.46243388,11 5.5,11 C8.53756612,11 11,8.53756612 11,5.5 C11,2.46243388 8.53756612,0 5.5,0 Z M5.5,1 C7.98528137,1 10,3.01471863 10,5.5 C10,7.98528137 7.98528137,10 5.5,10 C3.01471863,10 1,7.98528137 1,5.5 C1,3.01471863 3.01471863,1 5.5,1 Z" id="Oval"></path>
						</g>
					</g>
				</svg>
            </slot>
        </div>

        <div class="PageSearch-input">
            <input
                type="text"
                id="s"
                name="s"
                v-model="search"
				autocomplete="off"
				autocapitalize="off"
                :aria-placeholder="placeholder"
                :placeholder="placeholder"
                :class="{ 'is-invalid': isInvalid }"
            />
        </div>
    </form>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
    name: 'page-search',

    directives: {
        ClickOutside,
    },

    props: {
        action: {
            default: '/',
            type: String,
        },
        placeholder: {
            default: 'Search',
            type: String,
        },
        value: {
            default: null,
            type: String,
        },
        language: {
            default: '',
            type: String,
        },
		opened: {
        	default: false,
			type: Boolean,
		}
    },

    methods: {
        onHide(event) {
            this.isActive = false
        },

        onToggle(event) {
            if (!this.isActive) {
                this.isActive = true
            } else {
                this.onSubmit(event)
            }
        },

        onSubmit(event) {
            event.preventDefault()

            if (!this.search) {
                this.isActive = false
            } else {
                window.location.href = `${this.action}${this.language}?s=${this.search}`
            }
        },
    },

    data() {
        return {
            isActive: false,
            isInvalid: false,
            search: this.value,
        }
    },

	created() {
    	// if (this.opened) {
    	// 	this.isActive = true
		// }
	},
}
</script>
